import { getTranslateByKey } from "@/main/services/utils";

import * as S from "./styles";

function BackOrderBadge() {
	return <S.Container>{getTranslateByKey("information.backOrder")}</S.Container>;
}

export default BackOrderBadge;
